// extracted by mini-css-extract-plugin
export default {"component":"jBbtv","disabled":"ZetZo","radio":"yHHW7","input":"sqGlI","styledInput":"rZwKY","label":"edDqY"};